import React, { Suspense } from "react"
import RouteData from "./routeData"

const Index = () => {
  return <RouteData></RouteData>
}

export default Index
